import {createSlice} from '@reduxjs/toolkit';
import {calculateWindowSize} from '@app/utils/helpers';

const initialState = {
  isSidebarMenuCollapsed: false,
  screenSize: calculateWindowSize(window.innerWidth),
  corporateStructure: [],
  fetchCorpStructLoading: false,
  isFetchedCorpStruct: false,
  fetchCorpStructError: null,
};

export const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    toggleSidebarMenu: (state) => {
      state.isSidebarMenuCollapsed = !state.isSidebarMenuCollapsed;
    },
    setWindowSize: (state, {payload}) => {
      state.screenSize = payload;
    },
    fetchCorporateStructureRequest: (state) => {
      state.fetchCorpStructLoading = true;
      state.fetchCorpStructError = null;
    },
    fetchCorporateStructureSuccess: (state, {payload}) => {
      state.fetchCorpStructLoading = false;
      state.corporateStructure = payload;
      state.isFetchedCorpStruct = true;
    },
    fetchCorporateStructureError: (state, {payload}) => {
      state.fetchCorpStructLoading = false;
      state.isFetchedCorpStruct = true;
      state.fetchCorpStructError = payload;
    },
  },
});

export const {
  toggleSidebarMenu,
  setWindowSize,
  fetchCorporateStructureRequest,
  fetchCorporateStructureSuccess,
  fetchCorporateStructureError,
} = layoutSlice.actions;

export default layoutSlice.reducer;
